module.exports = __webpack_public_path__ + "img/onboarding-completed.d470aa71.png";